import React, { useContext } from 'react'
import { t } from 'i18next'
import { Input, Select } from 'antd'
import { ROLES } from '../../Common/Common'
import GlobalContext from '../GlobalContext'

export default function IntervenerFilter ({ filter, onChangeFilter }) {
  const { boxes } = useContext(GlobalContext)

  const onChange = (hash) => {
    onChangeFilter({ ...filter, ...hash })
  }
  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <Select
        showSearch={{
          optionFilterProp: 'children',
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }}
        allowClear={true}
        placeholder={t('Admin.IntervenerFilter.box')}
        style={{ width: '250px' }}
        onChange={(value) => onChange({ box_id: value || '' })}
        options={(boxes ?? []).map((o) => ({ label: o.name, value: o.id }))}
      />
      <Select
        showSearch={{
          optionFilterProp: 'children',
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }}
        allowClear={true}
        placeholder={t('Admin.IntervenerFilter.role')}
        style={{ width: '250px' }}
        onChange={(value) => onChange({ role: value || 'all' })}
        options={ROLES.map((role) => ({ label: t(`Admin.Intervener.attributes.role.${role}`), value: role }))}
      />
      <Input
        style={{ width: '250px' }}
        onChange={(e) => { onChange({ name: e.target.value }) }} placeholder={t('Admin.IntervenerFilter.name')}
        value={filter.name}
      />
    </div>
  )
}
